module.exports = __webpack_public_path__ + "media/images/card-background-list-73c141df63c7b01c3952cf4d5847caf1.png";